<div class="mw-date-range-picker__input" #trigger (click)="onTriggerClick()">
  <input
    matInput
    readonly
    #inputRef
    placeholder="{{ placeholder }}"
    (blur)="onInputBlur($event)"
  />
  <mat-icon
    *ngIf="value && options.clearable"
    class="mw-date-range-picker__input-close-btn"
    (click)="onClear($event)"
  >
    close
  </mat-icon>
  <mat-icon>today</mat-icon>
</div>
